import { Route } from "react-router";

import { AccountingGate } from "./AccountingGate";

/** Route element for both CustomRoutes blocks in CRM.tsx (desktop and mobile). */
export const accountingRoutes = [
  <Route key="accounting" path="/accounting/*" element={<AccountingGate />} />,
];
